import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {H4} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import CleanUpRow from '@freckle/school/ts/rostering/components/common/clean-up-row'
import DetailColumn from '@freckle/school/ts/rostering/components/common/detail-column'

type Props = {
  isChecked: boolean
  onChange?: () => void
  numUnmanagedCourses: number
  activeIdpsString: string
}

export function CleanUpCourses(props: Props) {
  const {isChecked, onChange, numUnmanagedCourses, activeIdpsString} = props
  const {t} = useSafeTranslation()

  return (
    <CleanUpRow
      src={`${PATHS.imageAssetsUrl}/school/icons/clean-up-courses.svg`}
      checkboxId="clean-up-courses"
      checkboxDataTest="clean-up-courses-checkbox"
      isChecked={isChecked}
      onChange={onChange}
      title={t('CLEAN_UP_COURSES_TITLE')}
      subTitle={t('CLEAN_UP_COURSES_SUBTITLE', {
        numUnmanagedCourses,
        activeIdpsString
      })}
      description={t('CLEAN_UP_COURSES_DESCRIPTION')}
    >
      <DetailColumn>
        <SafeTrans
          i18nKey="CLEAN_UP_COURSES_DETAIL_COL_1"
          components={{
            h4: <H4 />,
            ul: <ul />,
            li: <li />
          }}
        />
      </DetailColumn>
      <DetailColumn>
        <SafeTrans
          i18nKey="CLEAN_UP_COURSES_DETAIL_COL_2"
          components={{
            h4: <H4 />,
            ul: <ul />,
            li: <li />
          }}
        />
      </DetailColumn>
    </CleanUpRow>
  )
}
